import { NameInputChange } from "@screens/Expenses";
import { useEffect, useState } from "react";
import InputSelect from "../Receipt/select";
import { getCategories } from "@services";
import { useT } from "@hooks";
import SharedCreateDialog, { isDuplicatedName, useCategoryDialogFields } from "../SharedCreateDialog";

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (value: string, selectCategory?: string, selectType?: string) => void;
  title: string;
  placeholder: string;
  name?: string;
  type?: string;
  expenseType?: string;
  showDuplicateAlert?: boolean;
  duplicateAlertMessage?: string;
  existingSubcategories?: { name: string; categoryId: number }[];
  duplicateNameMessage?: string;
}

interface IcategoryOptionsProps {
  id: string;
  label: string;
}

const DialogCreateCategorySetttings = ({
  show,
  onClose,
  onSave,
  title,
  placeholder,
  name,
  type,
  expenseType,
  showDuplicateAlert = false,
  duplicateAlertMessage = "",
  existingSubcategories = [],
  duplicateNameMessage = "",
}: Props) => {
  const t = useT();
  const typeOptions = [
    { id: "DESPESA", label: t("dialog.type.expense") },
    { id: "RECEITA", label: t("dialog.type.recipe") },
  ];

  const {
    error,
    setError,
    errorCategorySelect,
    setErrorCategorySelect,
    errorTypeSelect,
    setErrorTypeSelect,
    valueCategory,
    setValueCategory,
    selectCategory,
    setSelectCategory,
    selectType,
    setSelectType,
    clearErrors,
    clearValues,
  } = useCategoryDialogFields(name, type, expenseType, show);

  const [selectCategoryOptions, setSelectCategoryOptions] = useState<IcategoryOptionsProps[]>([{ id: "", label: "" }]);

  const fetchCategories = async () => {
    try {
      const response = await getCategories();

      const filtered = response
        .filter((res) => res.type === selectType)
        .map((item: any) => ({ id: String(item.id), label: item.name }));

      setSelectCategoryOptions(filtered);
    } catch (error) {
      console.log(`error`, error);
    }
  };

  useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectType]);

  const namesInSelectedCategory = existingSubcategories
    .filter((existing) => String(existing.categoryId) === selectCategory)
    .map((existing) => existing.name);

  const isDuplicateName = !!selectCategory && isDuplicatedName(valueCategory, namesInSelectedCategory);

  const handleSubmit = () => {
    if (!valueCategory || !selectType || !selectCategory) {
      if (!valueCategory) {
        setError(t("common.label.requiredField"));
      }
      if (!selectType) {
        setErrorTypeSelect(t("common.label.requiredField"));
      }
      if (!selectCategory) {
        setErrorCategorySelect(t("common.label.requiredField"));
      }
      return;
    }

    if (isDuplicateName) return;

    clearErrors();
    clearValues();

    onSave(valueCategory, selectCategory, selectType);
  };

  const handleClose = () => {
    onClose();
    clearValues();
    clearErrors();
  };

  const inputChange = (name: NameInputChange, value?: string) => {
    setSelectCategory(value || "");
  };

  const typeCategoryChange = (name: NameInputChange, value?: string) => {
    setSelectType(value || "");
  };

  return (
    <SharedCreateDialog
      show={show}
      title={title}
      placeholder={placeholder}
      value={valueCategory}
      onValueChange={setValueCategory}
      error={error}
      isDuplicateName={isDuplicateName}
      duplicateNameMessage={duplicateNameMessage}
      showDuplicateAlert={showDuplicateAlert}
      duplicateAlertMessage={duplicateAlertMessage}
      onClose={handleClose}
      onSubmit={handleSubmit}
      useOverflow={false}
      fieldsBefore={
        <>
          <div className={`form-group ${errorTypeSelect ? "has-feedback has-error" : ""}`}>
            <InputSelect
              inputChange={typeCategoryChange}
              label={t("dialog.subcategory.typeQuestion")}
              name="category"
              onCreateNewOption={() => {}}
              options={typeOptions}
              value={selectType}
              errorMessage={errorTypeSelect}
            />
          </div>

          <div className={`form-group ${errorCategorySelect ? "has-feedback has-error" : ""}`}>
            <InputSelect
              inputChange={inputChange}
              label={t("dialog.subcategory.categoryQuestion")}
              name="category"
              onCreateNewOption={() => {}}
              options={selectCategoryOptions}
              value={selectCategory}
              errorMessage={errorCategorySelect}
            />
          </div>
        </>
      }
    />
  );
};

export default DialogCreateCategorySetttings;
